import script from "./PageHeaderSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeaderSearch.vue?vue&type=script&setup=true&lang=js"

import "./PageHeaderSearch.vue?vue&type=style&index=0&id=637d8add&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-637d8add"]])

export default __exports__